import { FORM_TYPES } from "../drafts/const/form";

export const BASIC = "/match";
export const LINKS = {
  EBAY: `${BASIC}/${FORM_TYPES.EBAY}`,
  ETSY: `${BASIC}/${FORM_TYPES.ETSY}`,
  POSHMARK: `${BASIC}/${FORM_TYPES.POSHMARK}`,
  MERCARI: `${BASIC}/${FORM_TYPES.MERCARI}`,
};
